export default __webpack_public_path__ + "static/media/mobileBackArrow.32add456.svg";